import { render, staticRenderFns } from "./advocacy-alert-widget-app.vue?vue&type=template&id=158a1700&"
import script from "./advocacy-alert-widget-app.vue?vue&type=script&lang=js&"
export * from "./advocacy-alert-widget-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports